import script from "./investWillAuditApplyList.vue?vue&type=script&lang=ts&setup=true"
export * from "./investWillAuditApplyList.vue?vue&type=script&lang=ts&setup=true"

import "./investWillAuditApplyList.vue?vue&type=style&index=0&id=1159d104&lang=less"

const __exports__ = script;

export default __exports__